import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Folder = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2034c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.9801-.6653-1.6097V6.0719c0-.6297.2218-1.1663.6653-1.6098s.98-.6652 1.6097-.6652h5.8385L12 5.8866h7.9282c.6297 0 1.1663.2218 1.6098.6653.4435.4433.6652.9799.6652 1.6097v9.7668c0 .6296-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653H4.0716z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2034c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.9801-.6653-1.6097V6.0719c0-.6297.2218-1.1663.6653-1.6098s.98-.6652 1.6097-.6652h5.8385L12 5.8866h7.9282c.6297 0 1.1663.2218 1.6098.6653.4435.4433.6652.9799.6652 1.6097v9.7668c0 .6296-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653H4.0716zm0-2.275h15.8565V8.1616h-8.8667L8.9716 6.072h-4.9v11.8565z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M4.0716 20.2034c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.9801-.6653-1.6097V6.0719c0-.6297.2218-1.1663.6653-1.6098s.98-.6652 1.6097-.6652h5.8385L12 5.8866h7.9282c.6297 0 1.1663.2218 1.6098.6653.4435.4433.6652.9799.6652 1.6097v9.7668c0 .6296-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653H4.0716zm0-2.275h15.8565V8.1616h-8.8667L8.9716 6.072h-4.9v11.8565z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Folder.displayName = "FolderIcon";

export { Folder, Folder as default };
